import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    // flexWrap: "wrap",
    justifyContent: 'center',
    textAlign: 'center'
  },
  textField: {
    textAlign: 'center'
  }  

}));


function getTime(now){
    let hour = now.getHours().toString().padStart(2, '0');
    let minute = now.getMinutes().toString().padStart(2, '0');
    let currentTime = `${hour}:${minute}`;
    return currentTime;
}

function getToday(today) {
    // const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}

export default function TimePicker(props) {
  const classes = useStyles();
  const [date, setDate]= React.useState(getToday(props.now));
  const [time, setTime]= React.useState(getTime(props.now));
  React.useEffect(() => {
    console.log('init timepicker');
    setDate(getToday(props.now));
    setTime(getTime(props.now));
    props.handleUpdate(date+' '+time);
    }, []); // empty array ensures that effect is only run on mount and unmount

  const handleClick = (e) =>{
    // console.log(date+time);
    props.handleUpdate(date+' '+time)
  }

  const handleEnter = (e) =>{
    if(e.key == 'Enter') {
      // console.log(date+time);
      props.handleUpdate(date+' '+time)
    }
  }
  const handleTimeChange = (e) => {
    //Function code goes here
    const timeData = e.target.value;
    console.log('time',timeData);    
    setTime(timeData);
  }

  const handleDateChange = (e) =>{
    const timeData = e.target.value;
    console.log('date',timeData);    
    setDate(timeData);
  }

  return (
    <form className={classes.container} style={{display: 'flex', justifyContent:'center' ,textAlign: 'center'}}>
      <TextField
        id="date-timeinput"
        label="Date"
        type="date"
        defaultValue={date}
        className={classes.textField}
        InputLabelProps={{
          shrink: true
        }}
        InputProps={{
            className:"dark:text-white",
            style: {
              fontSize: '1.6rem',
              textAlign: 'center'

              // color: 'white'
            },
            inputProps: {
                style: {
                  // textAlign: 'left'
                }
              }            
          }}
        onChange={(e) => handleDateChange(e)}      
        onKeyDown={(e)=> handleEnter(e)}        

      />
      <TextField
      id="time-timeinput"
      label="Time"
      type="time"
      defaultValue={time}
      className={classes.textField}
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
          className:"dark:text-white",
          style: {
            fontSize: '1.6rem',
            textAlign: 'center',
            // color: 'white'
          },
          inputProps: {
            style: {
              // textAlign: 'left'
            }
          }
        }}
      onChange={(e) => handleTimeChange(e)}
      onKeyDown={(e)=> handleEnter(e)}        
      />
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Button style={{marginLeft:'10px', marginTop:'10px', maxHeight:'40px'}} variant="contained" color="primary"
          onClick={e=>handleClick(e)}
        >변환</Button>
      </div>
    </form>
  );
}